export default __webpack_public_path__ + "static/media/logo.5770da60.png";